import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { sectionHook } from '../../lib/domHooks';

/**
 * Vega şemasının bölüm kabuğu.
 *
 * Referans arayüzde her şerit kendi kartının içindedir: sayfanın zemininden
 * bir ton açık, 5px köşeli bir yüzey. Başlığın yanında kategorinin **kalan
 * oyun sayısı** rozet olarak durur ("+6324") ve tam listeye gider; şeridin
 * sağ ucunda kaydırma okları vardır. Rozet yalnızca sayı bilindiğinde
 * çizilir — şeritte görünenden fazlası yoksa "+0" yazmak yerine hiç
 * çizilmez.
 */
const VegaSection = ({
  title, to, count = null, shown = 0, section, children,
}) => {
  const stripRef = useRef(null);

  const scroll = (direction) => {
    const el = stripRef.current;
    if (!el) return;
    el.scrollBy({ left: direction * Math.max(el.clientWidth * 0.8, 240), behavior: 'smooth' });
  };

  const remaining = Number.isFinite(count) ? Math.max(0, count - shown) : 0;

  return (
    <section className="vega-section" {...sectionHook(section)}>
      <div className="vega-section-head">
        <h2 className="vega-section-title">{title}</h2>
        {to && remaining > 0 && (
          <Link to={to} className="vega-section-count" aria-label={`${title} — tümünü gör`}>
            {`+${remaining}`}
          </Link>
        )}
        {to && remaining === 0 && (
          <Link to={to} className="vega-section-more">Tümü</Link>
        )}
        <div className="vega-section-nav">
          <button
            type="button"
            className="vega-nav-arrow"
            onClick={() => scroll(-1)}
            aria-label="Önceki"
          >
            <ChevronLeft size={15} />
          </button>
          <button
            type="button"
            className="vega-nav-arrow"
            onClick={() => scroll(1)}
            aria-label="Sonraki"
          >
            <ChevronRight size={15} />
          </button>
        </div>
      </div>
      <div className="vega-strip" ref={stripRef}>
        {children}
      </div>
    </section>
  );
};

export default VegaSection;
